import type { RarityTier } from '@gachakit/core/types/adapter';

const IUCN_RARITY: Record<string, RarityTier> = {
  CR: 'legendary',
  EN: 'epic',
  VU: 'rare',
  NT: 'uncommon',
  LC: 'common',
  DD: 'rare',
  EW: 'legendary',
  EX: 'legendary'
};

interface SpeciesRarityInput {
  id?: string | number;
  iucnRedListCategory?: string;
  numOccurrences?: number;
}

export function computeRarity(species: SpeciesRarityInput): RarityTier {
  const iucn = species.iucnRedListCategory;
  if (iucn && iucn in IUCN_RARITY) {
    return IUCN_RARITY[iucn];
  }

  if ((species.numOccurrences ?? 0) > 100000) {
    return 'common';
  }

  if ((species.numOccurrences ?? 0) > 10000) {
    return 'uncommon';
  }

  if ((species.numOccurrences ?? 0) > 1000) {
    return 'rare';
  }

  const roll = stablePercent(species.id ?? '0');
  if (roll < 58) {
    return 'common';
  }

  if (roll < 84) {
    return 'uncommon';
  }

  if (roll < 95) {
    return 'rare';
  }

  if (roll < 99) {
    return 'epic';
  }

  return 'legendary';
}

function stablePercent(value: string | number): number {
  const text = String(value);
  let hash = 0;
  for (let index = 0; index < text.length; index += 1) {
    hash = (hash * 31 + text.charCodeAt(index)) >>> 0;
  }

  return hash % 100;
}
